import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Subheader, CircularProgress, Paper } from 'material-ui';
import { fetchTaxCards, requestTaxDiscountInfo } from 'actions/EmployeeTaxCards';
import PanelMessage from 'components/panels/PanelMessage';
import styles from './styles/Cards';
import EmployeeTaxCard from './EmployeeTaxCard';

const EmployeeTaxCards = ({
  hasError, taxCardsError, taxCardsLoading, taxCardInfo, fetchCards,
}) => {
  useEffect(() => {
    fetchCards();
  }, []);

  if (taxCardsLoading) return <Paper style={styles.loading}><CircularProgress /></Paper>;

  if (hasError) {
    return (<PanelMessage
      type="error"
      iconName="error"
      message={taxCardsError.Message || <FormattedMessage id="error" values={{ name: <FormattedMessage id="taxCards.title" /> }} />}
    />);
  }

  return (
    <React.Fragment>
      <Subheader style={styles.subheader}><FormattedMessage id="taxCards.title" /></Subheader>

      <EmployeeTaxCard cardType={1} />
      <EmployeeTaxCard cardType={2} />

      {taxCardInfo &&
        <Paper style={styles.loading}>
          <div dangerouslySetInnerHTML={{ __html: taxCardInfo.TextBody }} />
        </Paper>
      }
    </React.Fragment>
  );
};

EmployeeTaxCards.propTypes = {
  hasError: PropTypes.bool,
  taxCardsError: PropTypes.object,
  taxCardsLoading: PropTypes.bool,
  taxCardInfo: PropTypes.object,
  fetchCards: PropTypes.func,
};

const mapStateToProps = ({ EmployeeTaxCardsReducer, WebValuesReducer }) => ({
  hasError: EmployeeTaxCardsReducer.hasError,
  taxCardsError: EmployeeTaxCardsReducer.taxCardsError,
  taxCardsLoading: EmployeeTaxCardsReducer.taxCardsLoading,
  taxCardInfo: EmployeeTaxCardsReducer.taxCardInfo,
  valuesByKey: WebValuesReducer.valuesByKey,
});

export default connect(
  mapStateToProps,
  dispatch => ({
    fetchCards: () => {
      dispatch(fetchTaxCards());
      dispatch(requestTaxDiscountInfo());
    },
  }),
)(EmployeeTaxCards);



// WEBPACK FOOTER //
// ./src/containers/pay/EmployeeTaxCards.js